module.exports = __webpack_public_path__ + "img/no-vehicle.feb1af42.png";